<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoEditar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoEditar">
            <form #form="ngForm" name="form" novalidate>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                    </div>
                </div>
                <div class="formgroup">
                    <div
                        class="p-fluid p-formgrid grid"
                        *ngIf="itemServico && !exibirSpinnerPrincipal"
                    >
                        <div class="field col-12 md:col-5">
                            <label htmlFor="descricao">Descrição</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                type="text"
                                pInputText
                                placeholder="Descrição do serviço"
                                name="descricao"
                                ngModel
                                [(ngModel)]="itemServico.descricao"
                                #descricao="ngModel"
                                required
                            />
                            <div
                                *ngIf="descricao.hasError('required') && descricao.touched"
                                class="alerta"
                            >
                                <span>Campo obrigatório!</span>
                            </div>
                        </div>

                        <div class="field col-12 md:col-4">
                            <label htmlFor="subgrupo">Grupo</label>
                            <p-dropdown
                                [options]="grupos"
                                optionLabel="label"
                                [filter]="true"
                                optionValue="value"
                                [(ngModel)]="itemServico.subgrupo"
                                emptyFilterMessage="Nenhum registro"
                                name="subgrupo"
                                ngModel
                                #subgrupo="ngModel"
                            ></p-dropdown>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="codigo">Código</label>
                            <input
                                type="text"
                                pInputText
                                name="codigo"
                                ngModel
                                #codigo="ngModel"
                                oninput="this.value = this.value.toUpperCase();"
                                required
                                (blur)="verificarCodigoExistente(codigo.value)"
                                [(ngModel)]="itemServico.codigo"
                            />
                            <div
                                *ngIf="codigo.hasError('required') && codigo.touched"
                                class="alerta"
                            >
                                <span>Campo obrigatório!</span>
                            </div>
                            <div
                                *ngIf="!codigo.hasError('required') && codigoExistente"
                                class="alerta"
                            >
                                Código já cadastrado!
                            </div>
                        </div>
                        <div class="field col-12 md:col-1">
                            <label htmlFor="comissaoVenda">Comissão</label>
                            <p-inputNumber
                                suffix="%"
                                name="comissaoVenda"
                                ngModel
                                #comissaoVenda="ngModel"
                                [max]="100"
                                [minFractionDigits]="2"
                                [maxFractionDigits]="2"
                                [allowEmpty]="false"
                                [(ngModel)]="itemServico.comissaoVenda"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorVenda">Valor Médio</label>
                            <div class="flex flex-row">
                                <p-inputNumber
                                    name="valorVenda"
                                    ngModel
                                    #valorVenda="ngModel"
                                    [allowEmpty]="false"
                                    [(ngModel)]="itemServico.valorVenda"
                                    mode="currency"
                                    inputId="currency-brazil"
                                    currency="BRL"
                                    locale="pt-BR"
                                    (onBlur)="calcularPorcentagemCustoMaterial()"
                                ></p-inputNumber>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Calcular precificação"
                                    (click)="abrirDialogValorSugerido()"
                                    icon="pi pi-percentage"
                                    class="p-button-success ml-2 w-4rem"
                                ></button>
                            </div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label>Tempo Médio</label>

                            <div class="flex">
                                <select
                                    class="form-control mr-1"
                                    [(ngModel)]="itemServico.tempoMedioHora"
                                    name="tempoMedioHora"
                                >
                                    <option *ngFor="let hora of horasServico" [value]="hora">
                                        {{ hora }}
                                    </option>
                                </select>

                                <select
                                    class="form-control"
                                    [(ngModel)]="itemServico.tempoMedioMinuto"
                                    name="tempoMedioMinuto"
                                >
                                    <option *ngFor="let minuto of minutosServico" [value]="minuto">
                                        {{ minuto }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label for="agenda">Agenda</label>
                            <p-dropdown
                                [options]="listaAgenda"
                                optionLabel="descricao"
                                optionValue="valor"
                                placeholder="Selecione"
                                name="agenda"
                                ngModel
                                #agenda="ngModel"
                                [(ngModel)]="itemServico.agenda"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-1">
                            <label for="tributacao">Tributável</label>
                            <br />
                            <p-inputSwitch
                                name="tributacao"
                                ngModel
                                #tributacao="ngModel"
                                [(ngModel)]="itemServico.tributacao"
                            ></p-inputSwitch>
                        </div>
                        <div class="field col-12 md:col-1">
                            <label for="ativo">Ativo</label>
                            <br />
                            <p-inputSwitch
                                name="ativo"
                                ngModel
                                #ativo="ngModel"
                                [(ngModel)]="itemServico.ativo"
                            ></p-inputSwitch>
                        </div>
                        <div class="col-12 mb-5 px-3">
                            <div class="card">
                                <h5>Custo Material do Serviço</h5>
                                <div class="p-fluid p-formgrid grid">
                                    <div class="field col-12 md:col-2">
                                        <div class="p-inputgroup">
                                            <p-inputNumber
                                                suffix="%"
                                                name="custoMaterial"
                                                ngModel
                                                #custoMaterial="ngModel"
                                                [max]="100"
                                                [minFractionDigits]="2"
                                                [maxFractionDigits]="2"
                                                [allowEmpty]="false"
                                                [(ngModel)]="itemServico.custoMaterial"
                                                [disabled]="listaItensCustoAdicionados.length > 0"
                                            ></p-inputNumber>
                                            <button
                                                pButton
                                                pRipple
                                                pTooltip="Adicionar Custo"
                                                (click)="abrirDialogCusto()"
                                                icon="pi pi-plus"
                                                class="p-button-success"
                                            ></button>
                                        </div>
                                    </div>
                                    <div
                                        class="field col-12 md:col-12"
                                        *ngIf="listaItensCustoAdicionados.length > 0"
                                    >
                                        <p-table
                                            #tabelaListaCusto
                                            [value]="listaItensCustoAdicionados"
                                            dataKey="id"
                                            [rows]="10"
                                            [rowHover]="true"
                                            styleClass="p-datatable-gridlines"
                                            [paginator]="false"
                                            responsiveLayout="scroll"
                                            styleClass=" p-datatable-sm"
                                        >
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <th>
                                                        <div>Código</div>
                                                    </th>
                                                    <th>
                                                        <div>Descrição</div>
                                                    </th>
                                                    <th>
                                                        <div>Quantidade UN Medida</div>
                                                    </th>

                                                    <th>
                                                        <div>Quantidade Utilizada</div>
                                                    </th>
                                                    <th>
                                                        <div>Valor de Custo</div>
                                                    </th>
                                                    <th>
                                                        <div>Excluir</div>
                                                    </th>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-item let-i="rowIndex">
                                                <tr>
                                                    <td>
                                                        <label>{{ item.itemProduto.codigo }}</label>
                                                    </td>
                                                    <td>
                                                        <label>
                                                            {{ item.itemProduto.descricao }}
                                                        </label>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            name="quantidadeUnidadeMedida{{ i }}"
                                                            [(ngModel)]="
                                                                item.quantidadeUnidadeMedida
                                                            "
                                                            pInputText
                                                            (input)="
                                                                calcularPorcentagemCustoMaterial()
                                                            "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            name="quantidade{{ i }}"
                                                            [(ngModel)]="item.quantidade"
                                                            pInputText
                                                            (input)="
                                                                calcularPorcentagemCustoMaterial()
                                                            "
                                                        />
                                                    </td>
                                                    <td>
                                                        <label class="form-control">
                                                            {{
                                                                (item.itemProduto.valorCompra /
                                                                    item.quantidadeUnidadeMedida) *
                                                                    item.quantidade
                                                                    | currency: "BRL"
                                                            }}
                                                        </label>
                                                    </td>

                                                    <td>
                                                        <button
                                                            pButton
                                                            pRipple
                                                            pTooltip="Excluir"
                                                            type="button"
                                                            icon="pi pi-trash"
                                                            class="p-button-danger"
                                                            (click)="
                                                                excluirItemCustoAdicionado(item)
                                                            "
                                                        ></button>
                                                    </td>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="summary">
                                                <div
                                                    class="flex align-items-center justify-content-between"
                                                >
                                                    <div>
                                                        Há
                                                        {{
                                                            listaItensCustoAdicionados
                                                                ? listaItensCustoAdicionados.length
                                                                : 0
                                                        }}
                                                        produtos inseridos no custo.
                                                    </div>
                                                    <div>
                                                        Total:
                                                        {{
                                                            valorTotalCustoMaterial
                                                                | currency: "BRL"
                                                        }}
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="p-fluid p-formgrid grid justify-content-between"
                        *ngIf="!exibirSpinnerPrincipal"
                    >
                        <div class="col-12 md:col-4">
                            <button
                                *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                                type="button"
                                pButton
                                icon="pi pi-check"
                                label="Atualizar"
                                (click)="atualizar()"
                                class="p-button-outlined p-button-success md:w-9rem"
                                [disabled]="!form.valid || codigoExistente || !itemServico"
                            ></button>
                            <ng-template #exibirBotaoFalso>
                                <button
                                    type="button"
                                    pButton
                                    icon="pi pi-spin pi-spinner"
                                    label="Atualizar"
                                    class="p-button-outlined p-button-success md:w-9rem"
                                    disabled
                                ></button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/item-servico"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
            <p-dialog
                header="Adicionar Custos do Serviço"
                [(visible)]="exibirDialogCusto"
                [modal]="true"
                [style]="{ width: '50vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <div class="card">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerDialog">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <p-table
                        #tabelaListaItensDisponiveis
                        [value]="listaItensDisponiveis"
                        dataKey="id"
                        [rows]="5"
                        [rowHover]="true"
                        styleClass="p-datatable-gridlines"
                        [paginator]="true"
                        responsiveLayout="scroll"
                        styleClass=" p-datatable-sm"
                        [globalFilterFields]="['codigo', 'descricao']"
                        *ngIf="!exibirSpinnerDialog"
                    >
                        <ng-template pTemplate="caption">
                            <div class="flex justify-content-end flex-column sm:flex-row">
                                <div>
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input
                                            pInputText
                                            type="text"
                                            #filter
                                            (input)="buscar(tabelaListaItensDisponiveis, $event)"
                                            placeholder="Buscar"
                                            class="w-full"
                                        />
                                    </span>
                                    <span class="ml-2">
                                        <button
                                            pButton
                                            class="p-button-outlined"
                                            icon="pi pi-filter-slash"
                                            pTooltip="Limpar Filtros"
                                            (click)="limpar(tabelaListaItensDisponiveis)"
                                        ></button>
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="codigo">
                                    <div>Código</div>
                                </th>
                                <th pSortableColumn="descricao">
                                    <div>Descrição</div>
                                </th>

                                <th style="text-align: center">
                                    <div>Selecionar</div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            <tr>
                                <td>
                                    <label>{{ item.codigo }}</label>
                                </td>
                                <td>
                                    <label>{{ item.descricao }}</label>
                                </td>

                                <td style="text-align: center">
                                    <button
                                        pButton
                                        pRipple
                                        pTooltip="Adicionar"
                                        type="button"
                                        icon="pi pi-check"
                                        class="p-button-success"
                                        (click)="adicionarItem(item)"
                                    ></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="flex align-items-center justify-content-between">
                                Há
                                {{ listaItensDisponiveis ? listaItensDisponiveis.length : 0 }} Itens
                                disponíveis.
                            </div>
                        </ng-template>
                    </p-table>
                </div>
                <p-footer>
                    <button
                        type="button"
                        pButton
                        icon="pi pi-times"
                        label="Cancelar"
                        class="p-button-danger mt-2"
                        (click)="exibirDialogCusto = false"
                    ></button>
                </p-footer>
            </p-dialog>

            <p-dialog
                [(visible)]="exibirDialogValorSugerido"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [style]="{ width: '35vw' }"
                [header]="'Sugestão de preço - ' + itemServico?.descricao"
                [modal]="true"
                [draggable]="false"
                [resizable]="false"
                class="p-fluid"
            >
                <ng-template pTemplate="content">
                    <div class="flex justify-content-center" *ngIf="loadingSpinnerDialog">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div class="formgrid grid" *ngIf="!loadingSpinnerDialog && itemServico">
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Custo Fixo</label>
                            <label class="label-inferior">
                                {{ custoMedio.custoFixo / 100 | percent: "1.2-2" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Custo Tributário</label>
                            <label class="label-inferior">
                                {{ custoMedio.imposto / 100 | percent: "1.2-2" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Custo Material</label>
                            <label class="label-inferior">
                                {{
                                    itemServico.custoMaterial
                                        ? (itemServico.custoMaterial / 100 | percent: "1.2-2")
                                        : "0,00%"
                                }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Comissão</label>
                            <label class="label-inferior">
                                {{
                                    itemServico.comissaoVenda
                                        ? (itemServico.comissaoVenda / 100 | percent: "1.2-2")
                                        : "0,00%"
                                }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Valor Serviço</label>
                            <label class="label-inferior">
                                {{ itemServico.valorVenda | currency: "BRL" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Lucro Atual</label>
                            <label class="label-inferior">
                                {{ valorLucroObtidoAtual | currency: "BRL" }} |
                                {{
                                    ((valorLucroObtidoAtual / (itemServico.valorVenda ?? 0)) *
                                        100) /
                                        100 | percent: "1.2-2"
                                }}
                            </label>
                        </div>
                        <div style="width: 100%">
                            <p-divider></p-divider>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="text-lg">Lucro Desejado</label>
                            <p-inputNumber
                                name="valorLucroDesejado"
                                ngModel
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                [(ngModel)]="valorLucroDesejado"
                                (onInput)="calcularLucroDesejado($event)"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="text-lg">Novo valor Serviço</label>
                            <p-inputNumber
                                name="novoValorServico"
                                ngModel
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                [(ngModel)]="novoValorServico"
                                (onInput)="calcularLucroObtido($event.value)"
                            ></p-inputNumber>
                        </div>

                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Valor Sugerido</label>
                            <label class="label-inferior">
                                {{ valorSugerido | currency: "BRL" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Lucro Obtido</label>
                            <label class="label-inferior" *ngIf="novoValorServico > 0">
                                <span
                                    class="product-badge bg-green-600 admihair-text-white"
                                    *ngIf="valorLucroObtido >= valorLucroDesejado"
                                >
                                    {{ valorLucroObtido | currency: "BRL" }}
                                </span>
                                <span
                                    class="product-badge bg-red-600 admihair-text-white"
                                    *ngIf="valorLucroObtido < valorLucroDesejado"
                                >
                                    {{ valorLucroObtido | currency: "BRL" }}
                                </span>
                            </label>
                            <label class="label-inferior" *ngIf="novoValorServico <= 0">
                                {{ valorLucroObtido | currency: "BRL" }}
                            </label>
                        </div>
                    </div>
                    <div class="flex justify-content-start mt-3" *ngIf="!loadingSpinnerDialog">
                        <button
                            pButton
                            pRipple
                            label="Confirmar"
                            icon="pi pi-check"
                            class="p-button-outlined w-full md:w-12rem"
                            (click)="confirmarValorServico()"
                            [disabled]="novoValorServico <= 0"
                        ></button>
                    </div>
                </ng-template>
            </p-dialog>
        </div>
    </div>
</div>
